// File: /src/components/FinancialDataForm.js

import React from 'react';
import '../styles/UserAccount.css';

function FinancialDataForm({
	userData,
	pixKeyInput,
	setPixKeyInput,
	handleFinancialSubmit,
}) {
	return (
		<div className="financial-data-section">
			<h2>Informações Financeiras</h2>
			<form
				onSubmit={handleFinancialSubmit}
				className="user-account-form"
				autoComplete="off"
			>
				<div className="form-row">
					<label htmlFor="pixKey">Chave Pix:</label>
					<input
						type="text"
						name="pixKey"
						id="pixKey"
						value={pixKeyInput}
						onChange={(e) => setPixKeyInput(e.target.value)}
						placeholder="Digite sua chave Pix"
					/>
				</div>
				{/* Exibe a chave Pix atual (persistida) abaixo do campo */}
				{userData.pixKey && (
					<div className="form-row">
						<p
							style={{
								fontSize: '0.9rem',
								color: 'var(--subtext-color)',
							}}
						>
							Chave Pix atual: {userData.pixKey}
						</p>
					</div>
				)}
				<div className="form-row">
					<button type="submit">Salvar Chave Pix</button>
				</div>
			</form>
		</div>
	);
}

export default FinancialDataForm;
